import {
  BillingCardCollectionType,
  OrganizationUnitType,
} from '@institutions/graphql';
import { buildDialogUrl } from '@common/services';
import { RolesResponse } from '@clinician-profile/graphql';

// Type definitions for filters and table data
export type FilterOption = {
  text: string;
  value: string;
};

export type FiltersData = {
  organizationUnits?: OrganizationUnitType[];
  roles?: RolesResponse['roles'];
  roleLevels?: string[];
};

export type SelectedFilters = Record<string, string[] | null>;

export type SortingData = {
  columnKey?: string;
  order?: 'ascend' | 'descend';
};

export type TableChangeParams = {
  current?: number;
  pageSize?: number;
};

const SORTING_DICTIONARY: Record<string, string> = {
  ascend: 'ASC',
  descend: 'DESC',
};

const COLUMN_NAMES_DICTIONARY: Record<string, string> = {
  clinicalUnit: 'clinicalOrder',
  unitName: 'unitOrder',
  costCenter: 'costCenterOrder',
  business: 'businessOrder',
  role: 'roleOrder',
  level: 'levelOrder',
  lastUpdated: 'createdAtOrder',
};

function translateSortingData({
  columnKey,
  order,
}: {
  columnKey?: string;
  order?: string;
}) {
  return columnKey && order
    ? { [COLUMN_NAMES_DICTIONARY[columnKey]]: SORTING_DICTIONARY[order] }
    : {};
}

export function normalizeSortingData(
  sortingData: SortingData | SortingData[]
): Record<string, string> {
  const arrayToObject = (
    current: Record<string, string>,
    next: Record<string, string>
  ) => ({ ...current, ...next });
  return [sortingData]
    .flat()
    .map(translateSortingData)
    .reduce(arrayToObject, {});
}

export function openInfoDrawerWhenRateCardExists(
  record: BillingCardCollectionType,
  navigate: (path: string) => void
) {
  const { organizationUnit, role, roleLevel, billingCard } = record;

  if (billingCard) {
    const drawerUrl = buildDialogUrl('rates-long-term-view-drawer', {
      props: {
        roleLevel,
        roleId: role.id,
        organizationUnitId: organizationUnit.id,
      },
    });

    return () => navigate(drawerUrl);
  }

  return null;
}
